import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { TableAction, TableActionDisplay, TableActionOptions } from "@app/shared/model/action.model";
import { NgChanges } from "@app/shared/model/ng-changes.model";
import { Subject } from "rxjs";

@Component({
    selector: "clare-table-custom-action",
    templateUrl: "./table-custom-action.component.html",
    styleUrls: ["./table-custom-action.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCustomActionComponent implements OnChanges {
    @Input() selectedRow: any;
    @Input() tableActionOptions: TableActionOptions;
    @Output() selectRow = new EventEmitter<undefined>();

    actionList$ = new Subject<TableAction[]>();
    actionModel: TableAction = undefined;
    isTopBarDisplay = false;

    ngOnChanges(changes: NgChanges<TableCustomActionComponent>) {
        if (changes.selectedRow) {
            this.updatedSelectionListener(changes.selectedRow.currentValue);
        }

        if (changes.tableActionOptions) {
            this.isTopBarDisplay = changes.tableActionOptions.currentValue.display === TableActionDisplay.dynamicBar;
        }
    }

    selectAction($event: TableAction) {
        if (typeof $event?.emitAction === "function") {
            $event.emitAction();
        }

        // For updating actionModel to not be blank.
        setTimeout(() => {
            this.actionModel = undefined;
        });
        this.updatedSelectionListener(this.selectedRow);
    }

    updatedSelectionListener(selectedRow: any) {
        if (selectedRow) {
            this.tableActionOptions?.selectionListener(selectedRow, this.actionList$);
        } else {
            this.actionList$.next([]);
        }
    }

    onClearSelection(event: Event) {
        event.preventDefault();
        this.selectRow.emit(undefined);
    }
}
